// extracted by mini-css-extract-plugin
export default {"root":"styles_root__pZBn5","title":"styles_title__-GlC3","caption":"styles_caption__J4Yay","submit":"styles_submit__kGVtK"};